<template>
   <vue-final-modal
      v-model="drugsModal" 
      @click-outside="beforeClose()"
      classes="modal-container"
      content-class="v310-modal-content"
      drag-selector=".drug-area"
      :drag="true"
      >
      <!-- 
      @before-close="beforeClose()"
      @click-outside="$emit('cancel')"
      -->
      <div class="drug-area">
      <button 
            id="dlast"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="currentLastTabIndex + 5" 
            @click="beforeClose()"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Drogas Prescriptas</span>
      </div>
      <!-- 
      <div class="up-voucher rounded-2 border p-2">
            @click="$emit('cancel')"
      -->
      <div class="up-voucher border-top p-1 mt-1">
         <div class="container">
            <Form
               @submit="nextStep"
               :validation-schema="currentSchema"
               keep-values
               v-slot="{ resetForm, meta }"
               :initial-values="dataDrugs"
               >
               
               <div tabindex="11" onfocus="document.getElementById('dlast').focus()"></div>
               <!-- first data disease,... -->
               <template v-if="currentStep === 0">

                  <div class="row">
                     <div class="col-10 ps-0">
                        <select-field 
                           :fieldData="drugsCnf.disease" 
                           :tabindex="12" 
                           :options="chronics" 
                           id="dfirst"
                           />
                     </div>
                     <button 
                           type="submit" 
                           :tabindex="13" 
                           class="btn btn-sm col-2 order-md-last p-0 text-end pe-2" 
                        >
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-capsule tx-cl-white" viewBox="0 0 16 16">
                        <path d="M1.828 8.9 8.9 1.827a4 4 0 1 1 5.657 5.657l-7.07 7.071A4 4 0 1 1 1.827 8.9Zm9.128.771 2.893-2.893a3 3 0 1 0-4.243-4.242L6.713 5.429l4.243 4.242Z"/>
                     </svg>
                     </button>
                  </div>
                  <!--
                  -->
               </template>
               
               <!-- second data drug, dose,... -->
               <template v-if="currentStep === 1">

                  <div class="row justify-content-between">
                     <div class=" col-10 row justify-content-between m-0">
                        <div class=" col-10 col-md-5 p-0 m-0">
                           <common-field :fieldData="drugsCnf.drug" :tabindex="12" :id="'dfirst'"/>
                        </div>
                        <div class=" col-10 col-md-5 p-0 m-0">
                           <common-field :fieldData="drugsCnf.dose" :tabindex="13"/>
                        </div>
                     </div>
                     <div class=" col-2 text-center m-0 align-self-end">
                        <button v-if="currentStep == lastStep && meta.valid"
                              type="submit" 
                              :tabindex="currentLastTabIndex" 
                              class="btn btn-sm"
                              >
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg tx-cl-white" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                           </svg>
                        </button>
                     </div>
                  </div>
                  <!--
                  -->
               </template>

               <div v-if=" disease != '' " class=" row justify-content-between border-top mt-3 p-0 ">
                  <div class="col-8">{{chronics[disease].name}}</div>
                  <div class="col-1 text-center px-0">{{chronics[disease].pathologyId}}</div>
                  <div class="col-1 text-center px-0">{{chronics[disease].diseaseId}}</div>
                  <div class="col-2 text-center px-0">
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 1" 
                           class="btn btn-sm" 
                           @click="prevStep()"
                           >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil tx-cl-white" viewBox="0 0 16 16">
                           <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                        </svg>
                     </button>
                  </div>
                  <div v-for="(item, index) in drugs" :key="index" class=" row p-0 m-0">
                     <div class="col-1 text-center px-0">{{item.code}}</div>
                     <div class="col-7">{{item.name}}</div>
                     <div class="col-2 text-center px-0">{{item.dose}}</div>
                     <div class="col-2 text-center px-0">
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 1" 
                           class="btn btn-sm" 
                           @click="deleteDrug(index)"
                           >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3 tx-cl-white" viewBox="0 0 16 16">
                           <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                        </svg>
                     </button>
                     </div>
                  </div>
               </div>

               <div class=" row border-top mt-3"></div>

               <div class="row p-0">
                  <div class="d-flex justify-content-end pt-2 px-0">
                     <button v-show="false"
                           type="button" 
                           :tabindex="currentLastTabIndex + 2" 
                           class="btn btn-outline-light btn-sm me-2"
                           @click="resetForm()"
                           id="reset"
                           >
                        Reset
                     </button>
                     <!-- 
                     -->
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 3" 
                           class="btn btn-outline-light btn-sm me-2"
                           @click="saveDrugs()"
                           ref="save_btn"
                           >
                        Guardar
                     </button>
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 4" 
                           class="btn btn-outline-light btn-sm" 
                           @click="beforeClose()"
                           id="dlastima"
                           >
                        Salir
                     </button>
                     <div :tabindex="currentLastTabIndex + 5" onfocus="document.getElementById('dfirst').focus()"></div>
                  </div>
               </div>
               <!--
               <pre>{{ v310drugs }}</pre>
               <pre>{{ dataDrugs }}</pre>
               <pre>{{ values }}</pre>
               <pre>{{ disease }}</pre>
               <pre>{{ drugs }}</pre>
               <pre>{{ meta }}</pre>
               <pre>{{ cuil }}</pre>
               -->
            </Form>
         </div>
      </div>
   </vue-final-modal>
</template>

<script>

import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick, onMounted } from 'vue';
import { Form, configure, defineRule } from 'vee-validate';
import * as yup from 'yup';

import V310Service from '../voucher310.service';

import CommonField from './CommonField.vue';
import SelectField from './SelectField.vue';

configure({
  validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
  validateOnChange: true, // controls if `change` events should trigger validation with `handleChange` handler
  validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
  validateOnModelUpdate: true, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
});

export default {

   components: {
      Form,
      VueFinalModal,
      CommonField,
      SelectField
   },
   props: {
      chronics: Object,
      v310drugs: Object,
      cuil: Number
   },

   emits: [ 'cancel', 'upDrugs', 'freeDrug' ],

   setup(props, { emit }) {

      defineRule('dfrValidDrug', value => {

         if ( isNaN( value ) ) { return 'Debe ser un número!' }
         if ( value < 1) { return 'Debe ser mayor o igual a uno!' }
         if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }
         if ( props.v310drugs[value] != undefined ) { return 'Código ya ingresado!' }

         return dfrValidDrug310( value )
      });

      const drugsModal = ref(true)
      const currentStep = ref(0);
      const lastStep = 1

      const dataDrugs = ref({})
      const disease = ref("")
      const drugs = ref([])
      const v310drug = ref({})

      const save_btn = ref(null)

      const lastTabIndex = [ 14, 15 ]

      const drugsSchema = [
         yup.object({
            disease: yup.string().required("Dato requerido!")
         }),
         {
            drug: 'dfrValidDrug',
            dose: yup.number()
               .required("Dato requerido!")
               .typeError("Debe ser un Número")
               .positive("Debe ser mayor a cero")
         }
      ]

      const drugsCnf = {
         disease: {
            name: 'disease',
            label: 'Enfermedad'
         },
         drug: {
            name: 'drug',
            label: 'Monodroga',
            type: 'text'
         },
         dose: {
            name: 'dose',
            label: 'Dosis',
            type: 'text'
         }
      }

      const currentSchema = computed(() => {
         //console.log(currentStep.value)
         return drugsSchema[currentStep.value];
      })

      const currentLastTabIndex = computed(() => {
         return lastTabIndex[currentStep.value];
      })

      onMounted(() => {
         save_btn.value.disabled = true
      })

      function beforeClose() {
         for ( let key in drugs.value) {
            emit( 'freeDrug', {index: drugs.value[key].code, option: false})
            //console.log( {index: drugs.value[key].code, option: false})
            console.log( key)
         }
         emit('cancel')
      }

      function deleteDrug(index) {
         emit( 'freeDrug', {index: drugs.value[index].code, option: false})
         drugs.value.splice( index, 1)
         if ( currentStep.value == 1 && drugs.value.length > 0) {
            save_btn.value.disabled = false
         } else {
            save_btn.value.disabled = true
         }
      }

      function nextStep(values) {

         if (currentStep.value == lastStep) {
            console.log(v310drug.value);
            console.log(v310drug.value); //_rawValue);
            drugs.value.push({
               code: values['drug'],
               dose: values['dose'],
               name: v310drug.value.name, //v310drug.value.name,
               id: v310drug.value.id //v310drug.value.id
            })
            //props.v310drugs[values['drug']].free = false
            emit( 'freeDrug', {
               index: values['drug'],
               option: true,
               dose: values['dose'],
               name: v310drug.value.name
               })
            nextTick(() => {
               document.getElementById('reset').click()
               document.getElementById('dfirst').focus()
            })
            //return;
         } else {
            dataDrugs.value['disease'] = values['disease']
            disease.value = values['disease']
            currentStep.value = 1
            nextTick(() => {
               document.getElementById('dfirst').focus()
            })
         }
         if ( currentStep.value == 1 && drugs.value.length > 0) {
            save_btn.value.disabled = false
         }
      }

      function prevStep() {
         if (currentStep.value <= 0) {
            return;
         }

         currentStep.value--;
         if (currentStep.value == 0) {
            save_btn.value.disabled = true
         }
      }

      function saveDrugs() {
         let done = {
            //disease: disease.value,
            disease: props.chronics[disease.value],
            drugs: drugs.value
         }
         emit( 'upDrugs', done)
         console.log(done)

         disease.value = ""
         drugs.value = []
         dataDrugs.value = {}
         document.getElementById('reset').click()

         prevStep()
         nextTick(() => {
            document.getElementById('reset').click()
            document.getElementById('dfirst').focus()
         })
      }

      async function dfrValidDrug310( value ) {

         let promise = new Promise(( resolve ) => {
            V310Service.findDrugCode310( value, props.cuil )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return 'Error de red!'
               });
         })

         let result = await promise
         if ( result == "") {
            return 'Código inexistente!'
         }
         v310drug.value = result
         return true
      }

      return {
         beforeClose,
         currentLastTabIndex, currentSchema, currentStep,
         dataDrugs, deleteDrug, disease, //diseases,
         drugs, drugsCnf, drugsModal,
         lastStep,
         nextStep,
         prevStep,
         save_btn, saveDrugs,
         v310drug
      }
   },
}
</script>

<style scoped>
/*
  margin: 0 1rem;
*/
.up-voucher {
   background-color: #9E9E9E ;
   /*
   margin-top: 10px ;
   max-width: 500px;
   */
   max-width: 500px;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.tx-cl-white {
   color: white;
}
</style>
